import { IdType } from "@/types";

export const ROUTES = {
  home: "/",
  users: {
    base: "/users",
    user: (userId: IdType) => `/users/${userId}`,
    userOrders: (userId: IdType) => `/users/${userId}/orders`,
    orderDetails: (userId: IdType, orderId: IdType) => `/users/${userId}/orders/${orderId}/details`,
    userPreferences: (userId: IdType) => `/users/${userId}/preferences`,
    orderPreferences: (userId: IdType, orderId: IdType) => `/users/${userId}/orders/${orderId}/preferences`,
    preferences: "/users/preferences",
  },
  products: {
    base: "/products",
    productOrders: (productId: IdType) => `/products/${productId}/orders`,
  },
};
